export var SECONDS_TO_MS = 1000;
export var MINUTES_TO_MS = 60 * SECONDS_TO_MS;
export var HOURS_TO_MS = 60 * MINUTES_TO_MS;
